import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { calculator } from '../../../base/utils';
import { API } from '../../../request/api';
import { _logout_user } from '../../../store/actions/login_actions';

const useDelivery = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [address_list, set_address_list] = useState([]);
  const [current_address, set_current_address] = useState(null);
  const address_list_ref = useRef(null);
  const [loading, set_loading] = useState(false);
  const Login = useSelector((store) => store.Login);
  const [message, setMessage] = useState(null);

  const getAddresses = () => {
    API.get
      .userAddresses(Login.city_id)
      .then((response) => {
        if (response.code === 200) {
          set_address_list(
            response.data.map((address_item) => ({
              address: address_item.address,
              location: `${address_item.province} - ${address_item.city} - ${address_item.region}`,
              zip_code: address_item.zip_code,
              id: address_item.id.toString()
            }))
          );
          // eslint-disable-next-line no-dupe-else-if
        } else if (response.code === 200 && response.data.length > 0) {
          set_current_address(response.data[0].id.toString());
        } else if (
          response.message.toLowerCase().includes('invalid') ||
          response.message.toLowerCase().includes('token')
        ) {
          let carfilloData = localStorage.getItem('carfillo');
          if (carfilloData) {
            carfilloData = JSON.parse(carfilloData);
            delete carfilloData.Login;
            carfilloData = JSON.stringify(carfilloData);
            localStorage.setItem('carfillo', carfilloData);
          }
          dispatch(_logout_user());
          calculator();
          if (Login.login_required) {
            history.push('/login/d');
          } else {
            history.push('/');
          }
        } else {
          // eslint-disable-next-line no-console
          console.error('Error: error while get address list');
        }
        set_loading(false);
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    API.get
      .config('delivery_page_message')
      .then((response) => {
        if (response.success) {
          setMessage(response.data.delivery_page_message);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    set_loading(true);
    getAddresses();
    // eslint-disable-next-line
  }, []);

  return [
    current_address,
    address_list,
    address_list_ref,
    set_current_address,
    loading,
    message,
    getAddresses
  ];
};
export default useDelivery;
